// NGT keyword taxonomy (keyword1 -> keyword2), keyed by zone_type.
// Source: https://www.greentribunal.gov.in/casestatus/keywordsearch (getKeyword.php).
// Used as an instant/offline fallback for the Keyword search dropdowns; the
// live values are fetched dynamically from the ngt-backend keyword endpoints.

const NGT_KEYWORD_MAP = {
  "1": {
    "zoneLabel": "Principal Bench",
    "keywords": [
      {
        "value": "51",
        "label": "Agriculture",
        "subKeywords": [
          {
            "value": "80",
            "label": "Agriculture"
          }
        ]
      },
      {
        "value": "104",
        "label": "Atomic Power Project",
        "subKeywords": [
          {
            "value": "105",
            "label": "Atomic Power Project"
          }
        ]
      },
      {
        "value": "40",
        "label": "Benefit Sharing",
        "subKeywords": [
          {
            "value": "69",
            "label": "Benefit Sharing"
          }
        ]
      },
      {
        "value": "41",
        "label": "Biodiversity",
        "subKeywords": [
          {
            "value": "70",
            "label": "Biodiversity"
          }
        ]
      },
      {
        "value": "6",
        "label": "Carcass/ Animal Waste",
        "subKeywords": [
          {
            "value": "17",
            "label": "Bio-medical Waste"
          },
          {
            "value": "18",
            "label": "Hazardous Waste"
          },
          {
            "value": "7",
            "label": "Plastic Wastage"
          },
          {
            "value": "16",
            "label": "Plastic Waste"
          },
          {
            "value": "15",
            "label": "Solid Waste"
          }
        ]
      },
      {
        "value": "43",
        "label": "Climate Change",
        "subKeywords": [
          {
            "value": "72",
            "label": "Climate Change"
          }
        ]
      },
      {
        "value": "50",
        "label": "Compensation",
        "subKeywords": [
          {
            "value": "79",
            "label": "Compensation"
          }
        ]
      },
      {
        "value": "44",
        "label": "Construction And Demolition",
        "subKeywords": [
          {
            "value": "73",
            "label": "Construction And Demolition"
          }
        ]
      },
      {
        "value": "53",
        "label": "Eco - Sensitive",
        "subKeywords": [
          {
            "value": "54",
            "label": "Crz"
          },
          {
            "value": "58",
            "label": "Ecologically Fragile Lands / Areas"
          },
          {
            "value": "59",
            "label": "Environmentally Sensitive Areas"
          },
          {
            "value": "56",
            "label": "Mangroves"
          },
          {
            "value": "57",
            "label": "Sand Dunes"
          },
          {
            "value": "55",
            "label": "Wetlands"
          }
        ]
      },
      {
        "value": "108",
        "label": "Encroachment",
        "subKeywords": [
          {
            "value": "109",
            "label": "Encroachment"
          }
        ]
      },
      {
        "value": "42",
        "label": "Environmental Clearance",
        "subKeywords": [
          {
            "value": "71",
            "label": "Environmental Clearance"
          }
        ]
      },
      {
        "value": "39",
        "label": "Fly Ash",
        "subKeywords": [
          {
            "value": "68",
            "label": "Fly Ash"
          }
        ]
      },
      {
        "value": "61",
        "label": "Forests",
        "subKeywords": [
          {
            "value": "83",
            "label": "Forests"
          }
        ]
      },
      {
        "value": "123",
        "label": "Fuel Station",
        "subKeywords": [
          {
            "value": "124",
            "label": "Petrol Pump"
          }
        ]
      },
      {
        "value": "45",
        "label": "Health",
        "subKeywords": [
          {
            "value": "74",
            "label": "Health"
          }
        ]
      },
      {
        "value": "46",
        "label": "Industries",
        "subKeywords": [
          {
            "value": "75",
            "label": "Industries"
          }
        ]
      },
      {
        "value": "38",
        "label": "Land Resources",
        "subKeywords": [
          {
            "value": "64",
            "label": "Blasting"
          },
          {
            "value": "114",
            "label": "Brick Kiln"
          },
          {
            "value": "65",
            "label": "Crusher"
          },
          {
            "value": "62",
            "label": "Mining"
          },
          {
            "value": "63",
            "label": "Quarrying"
          }
        ]
      },
      {
        "value": "49",
        "label": "National Highways",
        "subKeywords": [
          {
            "value": "78",
            "label": "National Highways"
          }
        ]
      },
      {
        "value": "118",
        "label": "Oil Leakage",
        "subKeywords": [
          {
            "value": "119",
            "label": "Oil Spill"
          }
        ]
      },
      {
        "value": "1",
        "label": "Pollution",
        "subKeywords": [
          {
            "value": "34",
            "label": "Air Pollution"
          },
          {
            "value": "36",
            "label": "Marine Pollution"
          },
          {
            "value": "37",
            "label": "Noise Pollution"
          },
          {
            "value": "35",
            "label": "Water Pollution"
          }
        ]
      },
      {
        "value": "120",
        "label": "Radiation",
        "subKeywords": [
          {
            "value": "121",
            "label": "Mobile Radiation"
          }
        ]
      },
      {
        "value": "2",
        "label": "Resources",
        "subKeywords": [
          {
            "value": "5",
            "label": "Sea"
          },
          {
            "value": "5",
            "label": "Water Resources"
          }
        ]
      },
      {
        "value": "106",
        "label": "Sewage/sewerage",
        "subKeywords": [
          {
            "value": "107",
            "label": "Sewage/sewerage"
          }
        ]
      },
      {
        "value": "47",
        "label": "Slaughter House",
        "subKeywords": [
          {
            "value": "76",
            "label": "Slaughter House"
          }
        ]
      },
      {
        "value": "6",
        "label": "Solid Waste Management",
        "subKeywords": [
          {
            "value": "17",
            "label": "Bio-medical Waste"
          },
          {
            "value": "18",
            "label": "Hazardous Waste"
          },
          {
            "value": "7",
            "label": "Plastic Wastage"
          },
          {
            "value": "16",
            "label": "Plastic Waste"
          },
          {
            "value": "15",
            "label": "Solid Waste"
          }
        ]
      },
      {
        "value": "52",
        "label": "Stp/cetp/etp",
        "subKeywords": [
          {
            "value": "81",
            "label": "Stp/cetp/etp"
          }
        ]
      },
      {
        "value": "48",
        "label": "Thermal Power Plant",
        "subKeywords": [
          {
            "value": "77",
            "label": "Thermal Power Plant"
          }
        ]
      },
      {
        "value": "110",
        "label": "Tree Felling",
        "subKeywords": [
          {
            "value": "111",
            "label": "Tree Felling"
          }
        ]
      },
      {
        "value": "116",
        "label": "Waste Management",
        "subKeywords": [
          {
            "value": "117",
            "label": "Carcass/ Animal Waste"
          }
        ]
      },
      {
        "value": "19",
        "label": "Water Resources",
        "subKeywords": [
          {
            "value": "27",
            "label": "Drain"
          },
          {
            "value": "31",
            "label": "Groundwater"
          },
          {
            "value": "30",
            "label": "Lakes/ponds"
          },
          {
            "value": "20",
            "label": "Rivers/canals"
          },
          {
            "value": "113",
            "label": "Sea"
          }
        ]
      },
      {
        "value": "60",
        "label": "Wildlife & Fisheries",
        "subKeywords": [
          {
            "value": "82",
            "label": "Wildlife & Fisheries"
          }
        ]
      }
    ]
  },
  "2": {
    "zoneLabel": "Eastern Zone",
    "keywords": [
      {
        "value": "51",
        "label": "Agriculture",
        "subKeywords": [
          {
            "value": "80",
            "label": "Agriculture"
          }
        ]
      },
      {
        "value": "41",
        "label": "Biodiversity",
        "subKeywords": [
          {
            "value": "70",
            "label": "Biodiversity"
          }
        ]
      },
      {
        "value": "6",
        "label": "Carcass/ Animal Waste",
        "subKeywords": [
          {
            "value": "17",
            "label": "Bio-medical Waste"
          },
          {
            "value": "18",
            "label": "Hazardous Waste"
          },
          {
            "value": "7",
            "label": "Plastic Wastage"
          },
          {
            "value": "16",
            "label": "Plastic Waste"
          },
          {
            "value": "15",
            "label": "Solid Waste"
          }
        ]
      },
      {
        "value": "50",
        "label": "Compensation",
        "subKeywords": [
          {
            "value": "79",
            "label": "Compensation"
          }
        ]
      },
      {
        "value": "44",
        "label": "Construction And Demolition",
        "subKeywords": [
          {
            "value": "73",
            "label": "Construction And Demolition"
          }
        ]
      },
      {
        "value": "53",
        "label": "Eco - Sensitive",
        "subKeywords": [
          {
            "value": "54",
            "label": "Crz"
          },
          {
            "value": "58",
            "label": "Ecologically Fragile Lands / Areas"
          },
          {
            "value": "59",
            "label": "Environmentally Sensitive Areas"
          },
          {
            "value": "57",
            "label": "Sand Dunes"
          },
          {
            "value": "55",
            "label": "Wetlands"
          }
        ]
      },
      {
        "value": "108",
        "label": "Encroachment",
        "subKeywords": [
          {
            "value": "109",
            "label": "Encroachment"
          }
        ]
      },
      {
        "value": "42",
        "label": "Environmental Clearance",
        "subKeywords": [
          {
            "value": "71",
            "label": "Environmental Clearance"
          }
        ]
      },
      {
        "value": "39",
        "label": "Fly Ash",
        "subKeywords": [
          {
            "value": "68",
            "label": "Fly Ash"
          }
        ]
      },
      {
        "value": "61",
        "label": "Forests",
        "subKeywords": [
          {
            "value": "83",
            "label": "Forests"
          }
        ]
      },
      {
        "value": "123",
        "label": "Fuel Station",
        "subKeywords": [
          {
            "value": "124",
            "label": "Petrol Pump"
          }
        ]
      },
      {
        "value": "45",
        "label": "Health",
        "subKeywords": [
          {
            "value": "74",
            "label": "Health"
          }
        ]
      },
      {
        "value": "46",
        "label": "Industries",
        "subKeywords": [
          {
            "value": "75",
            "label": "Industries"
          }
        ]
      },
      {
        "value": "38",
        "label": "Land Resources",
        "subKeywords": [
          {
            "value": "64",
            "label": "Blasting"
          },
          {
            "value": "114",
            "label": "Brick Kiln"
          },
          {
            "value": "65",
            "label": "Crusher"
          },
          {
            "value": "62",
            "label": "Mining"
          },
          {
            "value": "63",
            "label": "Quarrying"
          }
        ]
      },
      {
        "value": "49",
        "label": "National Highways",
        "subKeywords": [
          {
            "value": "78",
            "label": "National Highways"
          }
        ]
      },
      {
        "value": "118",
        "label": "Oil Leakage",
        "subKeywords": [
          {
            "value": "119",
            "label": "Oil Spill"
          }
        ]
      },
      {
        "value": "1",
        "label": "Pollution",
        "subKeywords": [
          {
            "value": "34",
            "label": "Air Pollution"
          },
          {
            "value": "36",
            "label": "Marine Pollution"
          },
          {
            "value": "37",
            "label": "Noise Pollution"
          },
          {
            "value": "35",
            "label": "Water Pollution"
          }
        ]
      },
      {
        "value": "106",
        "label": "Sewage/sewerage",
        "subKeywords": [
          {
            "value": "107",
            "label": "Sewage/sewerage"
          }
        ]
      },
      {
        "value": "52",
        "label": "Stp/cetp/etp",
        "subKeywords": [
          {
            "value": "81",
            "label": "Stp/cetp/etp"
          }
        ]
      },
      {
        "value": "48",
        "label": "Thermal Power Plant",
        "subKeywords": [
          {
            "value": "77",
            "label": "Thermal Power Plant"
          }
        ]
      },
      {
        "value": "110",
        "label": "Tree Felling",
        "subKeywords": [
          {
            "value": "111",
            "label": "Tree Felling"
          }
        ]
      },
      {
        "value": "116",
        "label": "Waste Management",
        "subKeywords": [
          {
            "value": "117",
            "label": "Carcass/ Animal Waste"
          }
        ]
      },
      {
        "value": "19",
        "label": "Water Resources",
        "subKeywords": [
          {
            "value": "27",
            "label": "Drain"
          },
          {
            "value": "31",
            "label": "Groundwater"
          },
          {
            "value": "30",
            "label": "Lakes/ponds"
          },
          {
            "value": "20",
            "label": "Rivers/canals"
          },
          {
            "value": "113",
            "label": "Sea"
          }
        ]
      },
      {
        "value": "60",
        "label": "Wildlife & Fisheries",
        "subKeywords": [
          {
            "value": "82",
            "label": "Wildlife & Fisheries"
          }
        ]
      }
    ]
  },
  "3": {
    "zoneLabel": "Central Zone",
    "keywords": [
      {
        "value": "51",
        "label": "Agriculture",
        "subKeywords": [
          {
            "value": "80",
            "label": "Agriculture"
          }
        ]
      },
      {
        "value": "41",
        "label": "Biodiversity",
        "subKeywords": [
          {
            "value": "70",
            "label": "Biodiversity"
          }
        ]
      },
      {
        "value": "6",
        "label": "Carcass/ Animal Waste",
        "subKeywords": [
          {
            "value": "17",
            "label": "Bio-medical Waste"
          },
          {
            "value": "18",
            "label": "Hazardous Waste"
          },
          {
            "value": "7",
            "label": "Plastic Wastage"
          },
          {
            "value": "15",
            "label": "Solid Waste"
          }
        ]
      },
      {
        "value": "50",
        "label": "Compensation",
        "subKeywords": [
          {
            "value": "79",
            "label": "Compensation"
          }
        ]
      },
      {
        "value": "44",
        "label": "Construction And Demolition",
        "subKeywords": [
          {
            "value": "73",
            "label": "Construction And Demolition"
          }
        ]
      },
      {
        "value": "53",
        "label": "Eco - Sensitive",
        "subKeywords": [
          {
            "value": "58",
            "label": "Ecologically Fragile Lands / Areas"
          },
          {
            "value": "59",
            "label": "Environmentally Sensitive Areas"
          },
          {
            "value": "57",
            "label": "Sand Dunes"
          },
          {
            "value": "55",
            "label": "Wetlands"
          }
        ]
      },
      {
        "value": "108",
        "label": "Encroachment",
        "subKeywords": [
          {
            "value": "109",
            "label": "Encroachment"
          }
        ]
      },
      {
        "value": "42",
        "label": "Environmental Clearance",
        "subKeywords": [
          {
            "value": "71",
            "label": "Environmental Clearance"
          }
        ]
      },
      {
        "value": "39",
        "label": "Fly Ash",
        "subKeywords": [
          {
            "value": "68",
            "label": "Fly Ash"
          }
        ]
      },
      {
        "value": "61",
        "label": "Forests",
        "subKeywords": [
          {
            "value": "83",
            "label": "Forests"
          }
        ]
      },
      {
        "value": "123",
        "label": "Fuel Station",
        "subKeywords": [
          {
            "value": "124",
            "label": "Petrol Pump"
          }
        ]
      },
      {
        "value": "45",
        "label": "Health",
        "subKeywords": [
          {
            "value": "74",
            "label": "Health"
          }
        ]
      },
      {
        "value": "46",
        "label": "Industries",
        "subKeywords": [
          {
            "value": "75",
            "label": "Industries"
          }
        ]
      },
      {
        "value": "38",
        "label": "Land Resources",
        "subKeywords": [
          {
            "value": "64",
            "label": "Blasting"
          },
          {
            "value": "114",
            "label": "Brick Kiln"
          },
          {
            "value": "65",
            "label": "Crusher"
          },
          {
            "value": "62",
            "label": "Mining"
          }
        ]
      },
      {
        "value": "49",
        "label": "National Highways",
        "subKeywords": [
          {
            "value": "78",
            "label": "National Highways"
          }
        ]
      },
      {
        "value": "1",
        "label": "Pollution",
        "subKeywords": [
          {
            "value": "34",
            "label": "Air Pollution"
          },
          {
            "value": "37",
            "label": "Noise Pollution"
          },
          {
            "value": "3",
            "label": "Water Pollution"
          }
        ]
      },
      {
        "value": "120",
        "label": "Radiation",
        "subKeywords": [
          {
            "value": "122",
            "label": "Radiation"
          }
        ]
      },
      {
        "value": "106",
        "label": "Sewage/sewerage",
        "subKeywords": [
          {
            "value": "107",
            "label": "Sewage/sewerage"
          }
        ]
      },
      {
        "value": "47",
        "label": "Slaughter House",
        "subKeywords": [
          {
            "value": "76",
            "label": "Slaughter House"
          }
        ]
      },
      {
        "value": "6",
        "label": "Solid Waste Management",
        "subKeywords": [
          {
            "value": "17",
            "label": "Bio-medical Waste"
          },
          {
            "value": "18",
            "label": "Hazardous Waste"
          },
          {
            "value": "7",
            "label": "Plastic Wastage"
          },
          {
            "value": "15",
            "label": "Solid Waste"
          }
        ]
      },
      {
        "value": "52",
        "label": "Stp/cetp/etp",
        "subKeywords": [
          {
            "value": "81",
            "label": "Stp/cetp/etp"
          }
        ]
      },
      {
        "value": "48",
        "label": "Thermal Power Plant",
        "subKeywords": [
          {
            "value": "77",
            "label": "Thermal Power Plant"
          }
        ]
      },
      {
        "value": "110",
        "label": "Tree Felling",
        "subKeywords": [
          {
            "value": "111",
            "label": "Tree Felling"
          }
        ]
      },
      {
        "value": "116",
        "label": "Waste Management",
        "subKeywords": [
          {
            "value": "117",
            "label": "Carcass/ Animal Waste"
          }
        ]
      },
      {
        "value": "19",
        "label": "Water Resources",
        "subKeywords": [
          {
            "value": "27",
            "label": "Drain"
          },
          {
            "value": "31",
            "label": "Groundwater"
          },
          {
            "value": "30",
            "label": "Lakes/ponds"
          },
          {
            "value": "20",
            "label": "Rivers/canals"
          }
        ]
      },
      {
        "value": "60",
        "label": "Wildlife & Fisheries",
        "subKeywords": [
          {
            "value": "82",
            "label": "Wildlife & Fisheries"
          }
        ]
      }
    ]
  },
  "4": {
    "zoneLabel": "Western Zone",
    "keywords": [
      {
        "value": "51",
        "label": "Agriculture",
        "subKeywords": [
          {
            "value": "80",
            "label": "Agriculture"
          }
        ]
      },
      {
        "value": "41",
        "label": "Biodiversity",
        "subKeywords": [
          {
            "value": "70",
            "label": "Biodiversity"
          }
        ]
      },
      {
        "value": "6",
        "label": "Carcass/ Animal Waste",
        "subKeywords": [
          {
            "value": "17",
            "label": "Bio-medical Waste"
          },
          {
            "value": "18",
            "label": "Hazardous Waste"
          },
          {
            "value": "7",
            "label": "Plastic Wastage"
          },
          {
            "value": "16",
            "label": "Plastic Waste"
          },
          {
            "value": "15",
            "label": "Solid Waste"
          }
        ]
      },
      {
        "value": "50",
        "label": "Compensation",
        "subKeywords": [
          {
            "value": "79",
            "label": "Compensation"
          }
        ]
      },
      {
        "value": "44",
        "label": "Construction And Demolition",
        "subKeywords": [
          {
            "value": "73",
            "label": "Construction And Demolition"
          }
        ]
      },
      {
        "value": "53",
        "label": "Eco - Sensitive",
        "subKeywords": [
          {
            "value": "54",
            "label": "Crz"
          },
          {
            "value": "58",
            "label": "Ecologically Fragile Lands / Areas"
          },
          {
            "value": "59",
            "label": "Environmentally Sensitive Areas"
          },
          {
            "value": "56",
            "label": "Mangroves"
          },
          {
            "value": "57",
            "label": "Sand Dunes"
          },
          {
            "value": "55",
            "label": "Wetlands"
          }
        ]
      },
      {
        "value": "108",
        "label": "Encroachment",
        "subKeywords": [
          {
            "value": "109",
            "label": "Encroachment"
          }
        ]
      },
      {
        "value": "42",
        "label": "Environmental Clearance",
        "subKeywords": [
          {
            "value": "71",
            "label": "Environmental Clearance"
          }
        ]
      },
      {
        "value": "39",
        "label": "Fly Ash",
        "subKeywords": [
          {
            "value": "68",
            "label": "Fly Ash"
          }
        ]
      },
      {
        "value": "61",
        "label": "Forests",
        "subKeywords": [
          {
            "value": "83",
            "label": "Forests"
          }
        ]
      },
      {
        "value": "45",
        "label": "Health",
        "subKeywords": [
          {
            "value": "74",
            "label": "Health"
          }
        ]
      },
      {
        "value": "46",
        "label": "Industries",
        "subKeywords": [
          {
            "value": "75",
            "label": "Industries"
          }
        ]
      },
      {
        "value": "38",
        "label": "Land Resources",
        "subKeywords": [
          {
            "value": "64",
            "label": "Blasting"
          },
          {
            "value": "114",
            "label": "Brick Kiln"
          },
          {
            "value": "65",
            "label": "Crusher"
          },
          {
            "value": "62",
            "label": "Mining"
          },
          {
            "value": "63",
            "label": "Quarrying"
          }
        ]
      },
      {
        "value": "49",
        "label": "National Highways",
        "subKeywords": [
          {
            "value": "78",
            "label": "National Highways"
          }
        ]
      },
      {
        "value": "1",
        "label": "Pollution",
        "subKeywords": [
          {
            "value": "34",
            "label": "Air Pollution"
          },
          {
            "value": "36",
            "label": "Marine Pollution"
          },
          {
            "value": "37",
            "label": "Noise Pollution"
          },
          {
            "value": "35",
            "label": "Water Pollution"
          }
        ]
      },
      {
        "value": "106",
        "label": "Sewage/sewerage",
        "subKeywords": [
          {
            "value": "107",
            "label": "Sewage/sewerage"
          }
        ]
      },
      {
        "value": "47",
        "label": "Slaughter House",
        "subKeywords": [
          {
            "value": "76",
            "label": "Slaughter House"
          }
        ]
      },
      {
        "value": "52",
        "label": "Stp/cetp/etp",
        "subKeywords": [
          {
            "value": "81",
            "label": "Stp/cetp/etp"
          }
        ]
      },
      {
        "value": "48",
        "label": "Thermal Power Plant",
        "subKeywords": [
          {
            "value": "77",
            "label": "Thermal Power Plant"
          }
        ]
      },
      {
        "value": "110",
        "label": "Tree Felling",
        "subKeywords": [
          {
            "value": "111",
            "label": "Tree Felling"
          }
        ]
      },
      {
        "value": "116",
        "label": "Waste Management",
        "subKeywords": [
          {
            "value": "117",
            "label": "Carcass/ Animal Waste"
          }
        ]
      },
      {
        "value": "19",
        "label": "Water Resources",
        "subKeywords": [
          {
            "value": "27",
            "label": "Drain"
          },
          {
            "value": "31",
            "label": "Groundwater"
          },
          {
            "value": "30",
            "label": "Lakes/ponds"
          },
          {
            "value": "20",
            "label": "Rivers/canals"
          },
          {
            "value": "113",
            "label": "Sea"
          }
        ]
      },
      {
        "value": "60",
        "label": "Wildlife & Fisheries",
        "subKeywords": [
          {
            "value": "82",
            "label": "Wildlife & Fisheries"
          }
        ]
      }
    ]
  },
  "5": {
    "zoneLabel": "Southern Zone",
    "keywords": [
      {
        "value": "51",
        "label": "Agriculture",
        "subKeywords": [
          {
            "value": "80",
            "label": "Agriculture"
          }
        ]
      },
      {
        "value": "104",
        "label": "Atomic Power Project",
        "subKeywords": [
          {
            "value": "105",
            "label": "Atomic Power Project"
          }
        ]
      },
      {
        "value": "41",
        "label": "Biodiversity",
        "subKeywords": [
          {
            "value": "70",
            "label": "Biodiversity"
          }
        ]
      },
      {
        "value": "6",
        "label": "Carcass/ Animal Waste",
        "subKeywords": [
          {
            "value": "17",
            "label": "Bio-medical Waste"
          },
          {
            "value": "18",
            "label": "Hazardous Waste"
          },
          {
            "value": "7",
            "label": "Plastic Wastage"
          },
          {
            "value": "16",
            "label": "Plastic Waste"
          },
          {
            "value": "15",
            "label": "Solid Waste"
          }
        ]
      },
      {
        "value": "43",
        "label": "Climate Change",
        "subKeywords": [
          {
            "value": "72",
            "label": "Climate Change"
          }
        ]
      },
      {
        "value": "50",
        "label": "Compensation",
        "subKeywords": [
          {
            "value": "79",
            "label": "Compensation"
          }
        ]
      },
      {
        "value": "44",
        "label": "Construction And Demolition",
        "subKeywords": [
          {
            "value": "73",
            "label": "Construction And Demolition"
          }
        ]
      },
      {
        "value": "53",
        "label": "Eco - Sensitive",
        "subKeywords": [
          {
            "value": "54",
            "label": "Crz"
          },
          {
            "value": "58",
            "label": "Ecologically Fragile Lands / Areas"
          },
          {
            "value": "59",
            "label": "Environmentally Sensitive Areas"
          },
          {
            "value": "56",
            "label": "Mangroves"
          },
          {
            "value": "57",
            "label": "Sand Dunes"
          },
          {
            "value": "55",
            "label": "Wetlands"
          }
        ]
      },
      {
        "value": "108",
        "label": "Encroachment",
        "subKeywords": [
          {
            "value": "109",
            "label": "Encroachment"
          }
        ]
      },
      {
        "value": "42",
        "label": "Environmental Clearance",
        "subKeywords": [
          {
            "value": "71",
            "label": "Environmental Clearance"
          }
        ]
      },
      {
        "value": "39",
        "label": "Fly Ash",
        "subKeywords": [
          {
            "value": "68",
            "label": "Fly Ash"
          }
        ]
      },
      {
        "value": "61",
        "label": "Forests",
        "subKeywords": [
          {
            "value": "83",
            "label": "Forests"
          }
        ]
      },
      {
        "value": "123",
        "label": "Fuel Station",
        "subKeywords": [
          {
            "value": "124",
            "label": "Petrol Pump"
          }
        ]
      },
      {
        "value": "45",
        "label": "Health",
        "subKeywords": [
          {
            "value": "74",
            "label": "Health"
          }
        ]
      },
      {
        "value": "46",
        "label": "Industries",
        "subKeywords": [
          {
            "value": "75",
            "label": "Industries"
          }
        ]
      },
      {
        "value": "38",
        "label": "Land Resources",
        "subKeywords": [
          {
            "value": "64",
            "label": "Blasting"
          },
          {
            "value": "67",
            "label": "Blue Metal"
          },
          {
            "value": "114",
            "label": "Brick Kiln"
          },
          {
            "value": "65",
            "label": "Crusher"
          },
          {
            "value": "66",
            "label": "Granite"
          },
          {
            "value": "62",
            "label": "Mining"
          },
          {
            "value": "63",
            "label": "Quarrying"
          }
        ]
      },
      {
        "value": "49",
        "label": "National Highways",
        "subKeywords": [
          {
            "value": "78",
            "label": "National Highways"
          }
        ]
      },
      {
        "value": "118",
        "label": "Oil Leakage",
        "subKeywords": [
          {
            "value": "119",
            "label": "Oil Spill"
          }
        ]
      },
      {
        "value": "1",
        "label": "Pollution",
        "subKeywords": [
          {
            "value": "4",
            "label": "Air Pollution"
          },
          {
            "value": "36",
            "label": "Marine Pollution"
          },
          {
            "value": "37",
            "label": "Noise Pollution"
          },
          {
            "value": "3",
            "label": "Water Pollution"
          }
        ]
      },
      {
        "value": "2",
        "label": "Resources",
        "subKeywords": [
          {
            "value": "5",
            "label": "Water Resources"
          }
        ]
      },
      {
        "value": "106",
        "label": "Sewage/sewerage",
        "subKeywords": [
          {
            "value": "107",
            "label": "Sewage/sewerage"
          }
        ]
      },
      {
        "value": "6",
        "label": "Solid Waste Management",
        "subKeywords": [
          {
            "value": "17",
            "label": "Bio-medical Waste"
          },
          {
            "value": "18",
            "label": "Hazardous Waste"
          },
          {
            "value": "7",
            "label": "Plastic Wastage"
          },
          {
            "value": "16",
            "label": "Plastic Waste"
          },
          {
            "value": "15",
            "label": "Solid Waste"
          }
        ]
      },
      {
        "value": "52",
        "label": "Stp/cetp/etp",
        "subKeywords": [
          {
            "value": "81",
            "label": "Stp/cetp/etp"
          }
        ]
      },
      {
        "value": "48",
        "label": "Thermal Power Plant",
        "subKeywords": [
          {
            "value": "77",
            "label": "Thermal Power Plant"
          }
        ]
      },
      {
        "value": "110",
        "label": "Tree Felling",
        "subKeywords": [
          {
            "value": "111",
            "label": "Tree Felling"
          }
        ]
      },
      {
        "value": "116",
        "label": "Waste Management",
        "subKeywords": [
          {
            "value": "117",
            "label": "Carcass/ Animal Waste"
          }
        ]
      },
      {
        "value": "19",
        "label": "Water Resources",
        "subKeywords": [
          {
            "value": "27",
            "label": "Drain"
          },
          {
            "value": "31",
            "label": "Groundwater"
          },
          {
            "value": "30",
            "label": "Lakes/ponds"
          },
          {
            "value": "20",
            "label": "Rivers/canals"
          },
          {
            "value": "113",
            "label": "Sea"
          }
        ]
      },
      {
        "value": "60",
        "label": "Wildlife & Fisheries",
        "subKeywords": [
          {
            "value": "82",
            "label": "Wildlife & Fisheries"
          }
        ]
      }
    ]
  }
};

export default NGT_KEYWORD_MAP;
